'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _commonFunctions = require('../../helpers/commonFunctions');

function populateCoverageData(context, data) {
  context.updateProp('application.additional_data.policy_type', data.additional_data.policy_type);
  context.updateProp('application.additional_data.country_of_origin', data.additional_data.country_of_origin);
  context.updateProp('application.additional_data.destination_province', data.additional_data.destination_province);
  context.updateProp('application.additional_data.deductible', data.additional_data.deductible);
  context.updateProp('application.additional_data.coverage', data.additional_data.coverage);
  context.updateProp('application.additional_data.in_canada', data.additional_data.in_canada);
  context.updateProp('application.additional_data.super_visa', data.additional_data.super_visa);
}

function populateQuestionnaireData(context, propPrefix, data) {
  for (var q = 1; q <= 11; q++) {
    (0, _commonFunctions.fillQuestion)(context, propPrefix, data, q);
  }
}

function populateApplicantsAdditionalData(context, data) {
  for (var i = 0; i < data.additional_data.additional_applicants_number + 1; i++) {
    populateQuestionnaireData(context, 'applicant[' + i + ']', data.additional_data.mq_answers[i]);
  }
}

function populateProductSpecificData(context, data) {
  populateCoverageData(context, data);
  populateApplicantsAdditionalData(context, data);
}

exports.default = function (context) {
  (0, _commonFunctions.populateQuoteData)(context, populateProductSpecificData);
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/rimi_vtc/quote.js
// module id = 1753
// module chunks = 0